import { cr, URLS, mo, ck } from "fire-wind-water";
import { $cmsData, settings } from "../common/setting";
import { scmsService } from "../services/site";
import { user } from "../user/index";
import * as $ from "jquery";
import { actionBrowse } from "../lifecycle/onInit/browse";

class fileDetail {
  $skelem = ".sk-cms-file-get";
  $user: any = {};
  isPreview: boolean = settings.isPreview;
  isDesign: boolean = settings.isDesign;
  tid: string = settings.tenantId || URLS.getURL("tid") || (window['siteParams']?window['siteParams'].tid:null);
  fid: string = URLS.getURL("fid");
  title = "";
  body = "";
  time = "";
  preview = "";
  down = "";
  size = "";
  recommendNum = 6;
  recommendStyle = {};
  constructor() {
    $sk.template.module(this);
  }
  skAfterViewChecked(): void {
    if (this.isPreview) {
      cr.each($cmsData.container, (item: { [label: string]: any }) => {
        cr.each(item, (d) => {
          if (d.type === "FILEDETAIL") {
            this.recommendNum = parseInt(d.historyContent.content.recommendNum);
            this.recommendStyle = d.historyContent.style.recommend;
            this.getDetail();
          }
          if (d.type === "NAV") {
            if (d.historyContent.basic.style.type == "bottomNav") {
              $(".file-detail-bottom-bar")
                .css(
                  "bottom",
                  "calc(18.2vw +  constant(safe-area-inset-bottom))"
                )
                .css("bottom", "calc(18.2vw +  env(safe-area-inset-bottom))");
            }
          }
        });
      });
    }
    const fid = URLS.getURL("fid");
    if (this.isDesign || !fid) {
      cr.each($cmsData.container, (item: { [label: string]: any }) => {
        cr.each(item, (d) => {
          if (d.type === "FILEDETAIL") {
            this.body = d.historyContent.content.body;
            this.time = d.historyContent.content.time;
            this.title = d.historyContent.content.title;

            this.down = d.historyContent.content.statInfo.downloadCount;
            this.preview = d.historyContent.content.statInfo.previewCount;
            this.size = d.historyContent.content.sizeFormat;
            this.initRecommenList(
              d.historyContent.content.recommendList,
              d.historyContent.style.recommend
            );
          }
          if (d.type === "NAV") {
            if (d.historyContent.basic.style.type == "bottomNav") {
              $(".file-detail-bottom-bar").css("bottom", "18.2vw");
            }
          }
        });
      });
    }
    if (settings.navType == "bottomNav") {
      $(".file-detail-bottom-bar")
        .css("bottom", "calc(18.2vw +  constant(safe-area-inset-bottom))")
        .css("bottom", "calc(18.2vw +  env(safe-area-inset-bottom))");
    }
  }
  skUserEnd() {
    this.updateUser();
  }
  updateUser() {
    const m = $sk.template.get();
    if (m.user.session) {
      this.$user.session = m.user.session;
    }
  }
  getDetail(): void {
    const fid = URLS.getURL("fid");
    const param = {
      fileId: fid,
      tenantId: this.tid,
      globalUserId: user.globalUserId,
    };
    scmsService.getFile(param).subscribe((res) => {
      if (res.result == 0) {
        this.body = res.content.preview.show;
        this.time = mo(res.content.modifyTime * 1000).format("YYYY-MM-DD");
        this.title = res.content.name;
        document.title = this.title;
        this.down = res.content.downCount;
        this.preview = res.content.previewNum;
        this.size = this.formatBytes(res.content.size);
        if (res.content.recommendList.length > 0) {
          this.initRecommenList(res.content.recommendList, this.recommendStyle);
        }
        actionBrowse();
      }
    });
  }
  formatBytes(bytes): string {
    const units = ["KB", "MB", "GB"];
    const fileSizeLimit = 1024; // 文件大小限制为1024字节
    let i = 0;
    while (bytes >= fileSizeLimit && i < units.length) {
      bytes /= fileSizeLimit;
      i++;
    }

    return `${bytes.toFixed(2)}${units[i - 1]}`;
  }
  initRecommenList(list, style) {
    let html = "";
    cr.each(list, (r, index) => {
      if (index < this.recommendNum) {
        html += `<div class="item" style="border-bottom-color: ${
          style && style.model == "custom" ? style.color4 : ""
        }"> <div class="list-dot" }"><span class="before" style="background-color: ${
          style && style.model == "custom" ? style.color : ""
        }"></span><span class="after" style="background-color: ${
          style && style.model == "custom" ? style.color : ""
        }"></span></div> <a href="${window.location.href.replace(
          URLS.getURL("fid"),
          r.fileId
        )}" class="title" style="color: ${
          style && style.model == "custom" ? style.color3 : ""
        }">${r.name}</a></div>`;
      }
    });
    $(".recommend-list").html(html);
  }

  downLoad() {
    if (settings.isPreview && URLS.getURL("preview")) {
      $sk.alert("当前为预览页面，不支持下载");
      return false;
    }
    this.getDownUrl();

    return false;
  }

  catchError(res: any): void {
    if (res.result == 0) {
      $sk.confirm("您尚未登录，是否去登录？", {
        ok() {
          $sk.goto(
            URLS.updateParam(
              "backUrl",
              encodeURIComponent(window.location.href),
              res.content.originUrl.wap
            )
          );
        },
      });
    } else {
      $sk.alert(res.desc);
    }
  }

  getDownUrl() {
    const filename = window.location.href.split("/").pop();
    const fid =
      URLS.getURL("fid") ||
      filename.slice(0, filename.lastIndexOf(".")).split("_")[2];
    const m = {
      tenantId: settings.tenantId,
      siteId: settings.siteId,
      fileId: fid,
      sess: this.$user.session || "",
      category: settings.category,
    };
    scmsService.getFileAuth(m).subscribe(
      (res) => {
        const d = parseInt(res.result, 10);
        if (res.content.isAuth === "has") {
          if (res.content.downloadType == 1) {
            window.location.replace(
              res.content.fileUrl +
                "&moduleType=36&sourceDownload=1&instanceId=" +
                settings.instanceId
            );
          } else {
            if (!ck.cookie("sendEmail")) {
              ck.cookie("sendEmail", res.content.sendEmail || "");
            }
            $(".error").html("");
            $("#down-email").val(ck.cookie("sendEmail") || "");
            $("#down-box").show();
          }
        } else {
          this.catchError(res);
        }
      },
      (err) => {
        this.catchError(err);
      }
    );
  }
  send() {
    const email = $("#down-email").val();
    const filename = window.location.href.split("/").pop();
    const fid =
      URLS.getURL("fid") ||
      filename.slice(0, filename.lastIndexOf(".")).split("_")[2];
    const reg =
      /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/;
    if (!reg.test(email)) {
      $(".error").html("请输入正确的邮箱");
      return;
    } else {
      $(".error").html("");
    }
    ck.cookie("sendEmail", $("#down-email").val());
    const param = {
      email: email,
      fileList: [fid],
      globalUserId: user.globalUserId,
      sess: this.$user.session || "",
      moduleType: 36,
      instanceId: settings.instanceId,
      tenantId: settings.tenantId,
    };
    scmsService.downloadWithEmail(param).subscribe((res) => {
      $("#down-box").hide();
      $("#down-email").val("");
      $sk.alert("文件已发送至邮箱");
    });
  }
  hide() {
    $("#down-box").hide();
  }
}
export { fileDetail };
